module.exports = __webpack_public_path__ + "img/footer-divider.2f3c8af1.png";